// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from "axios";
import { ajax, post } from './common/ajax';
import ajax2 from "./common/jqajax";
import store from './store/store';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { getCookie } from "@/common/util.js";
import "@/common/jquery.js"

import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false

Vue.prototype.$axios = axios;
Vue.prototype.$ajax = ajax2;
Vue.prototype.$ajax2 = ajax2;
Vue.prototype.$post = post;
Vue.prototype.$store = store;

import { mapState, mapMutations } from "vuex";
import { pagebreak } from "./custom";

Vue.filter('dateFormat', function (value) {
    if (!value) {
        return
    }
    var date = new Date(value);
    return date.getFullYear() + "-" + (date.getMonth() + 1 + "").padStart(2, "0") + "-" + (date.getDate() + "").padStart(2, "0");
})

Vue.use(pagebreak)

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    methods: {
        ...mapMutations(["logout"]),
    },
    created() {
        if (!getCookie("notAutoLogin")) {
            if (!this.autoLogin) {
                this.logout()
            }
        }
    },
    computed: {
        ...mapState(["autoLogin", "hasLogin"])
    }
})


// WEBPACK FOOTER //
// ./src/main.js